/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type RecipientMutationStatus =
    (typeof RecipientMutationStatus)[keyof typeof RecipientMutationStatus];

export const RecipientMutationStatus = {
    NotRequired: 0,
    Completed: 1,
    NoChange: 2,
    Failed: 3,
    Uncertain: 4,
} as const;
